// Global flag to suppress cart change handling
window.suppressCartChange = false;
//Add REMOVE GIFT PRODUCT
window.addRemoveGiftProduct = function addRemoveGiftProduct(CartItem, reloadPage = false,) {
  console.log("addRemoveGiftProduct >> cartItem", CartItem);

  function isEmptyObject(obj) {
    return JSON.stringify(obj) === '{}'
  }

  const items_to_add = [];
  const items_to_remove = {};
  let cartTotal = CartItem.total_price
  //let firstCartTotal = window.theme.custom.firstAmountOfCart * 100;
  //let secondCartTotal = window.theme.custom.secondAmountOfCart * 100;
  let freeProducts = window.theme.custom.freeProducts || [];
  let data = null;
  let cartUrl = null;

  window.createCartPromise().then(cart => {
    // Add items to cart if Cart total is high than minimun Value
    if (CartItem.items.length > 0) {

      let wonaGiftIds =  CartItem.items.filter(item => item.properties['_recharge_gift_variant_id']).map(item => item.properties['_recharge_gift_variant_id']);

      wonaGiftIds = wonaGiftIds.filter(id => cart.items.every(item => item.id != id));

      wonaGiftIds.forEach(id => {
        items_to_add.push({ id: id, quantity: 1, properties: { "_recharge_gift": (new Date()).getTime() } });
      });


      const rechargeGifts = CartItem.items.filter(item => item.properties['_recharge_gift']);
      rechargeGifts.forEach(gift => {
        let parrentProduct = cart.items.find(item => {
          return (item.properties['_recharge_gift_variant_id'] == gift.id)
        });
        if(!parrentProduct || (parrentProduct && (!parrentProduct.selling_plan_allocation || !parrentProduct.selling_plan_allocation.selling_plan))){
          items_to_remove[gift.id] = 0;
        }
      })

      let cartItemId = [];
      for (let item of CartItem.items) {
        cartItemId.push(item.variant_id)
      }

      freeProducts.forEach(productBase => {
        let variantId = productBase.product?.variants[0].id;
        if(productBase.variantId){
          variantId = productBase.variantId;
        }
        if(!variantId || variantId === "") return;
        let isAdded = CartItem.items.map(item => item.id).find(id => (id == variantId));
        let neededCartTotal = productBase.amount * 100;

        if(cartTotal < neededCartTotal && isAdded != undefined){
          let product = CartItem.items.find(item => item.id == variantId);
          if(product && product.properties && product.properties['_gift']) {
            items_to_remove[variantId] = 0;
          }
        }

        if (cartTotal >= neededCartTotal && cartItemId.indexOf(variantId) === -1) {
          items_to_add.push({ id: variantId, quantity: 1, properties: { "_gift": (new Date()).getTime() } });
        }
      });

      console.log("items to add", items_to_add);
      console.log("items to remove", items_to_remove);


      let sectionsToBundle = ["variant-added"];
      document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));

      let makeUpdate = false;
      if (!isEmptyObject(items_to_remove)) {
        data = { updates: items_to_remove };
        cartUrl = `${window.Shopify.routes.root}cart/update.js`;
        makeUpdate = true;
      }

      if (items_to_add.length) {
        data = { items: items_to_add };
        cartUrl = `${window.Shopify.routes.root}cart/add.js`;
        // data.sections_url = `${Shopify.routes.root}variants/${items_to_add[0].id}`;
      }

      if (data != null) {
        data.sections = sectionsToBundle.join(",");
        // Suppress cart change events during this fetch
        // alert('001 suppressCartChange = true;')
        window.suppressCartChange = true;
        fetch(cartUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data)
        })
          .then((res) => res.json())
          .then((responseJson) => { // Corrected this line
            // alert('002 suppressCartChange = true;')
            suppressCartChange = true; // Reset the flag
            if (reloadPage) {
              window.location.reload();
            } else {
              if (makeUpdate) {
                Object.keys(items_to_remove).forEach(itemId => {
                  document.querySelector(`line-item[data-variant="${itemId}"]`).dispatchEvent(new CustomEvent("line-item:change", {
                    bubbles: true,
                    detail: {
                      quantity: 0,
                      cart: responseJson
                    }
                  }));
                  document.dispatchEvent(new CustomEvent("cart:change", {
                    bubbles: true,
                    detail: {
                      baseEvent: "line-item:change",
                      cart: responseJson,
                    },
                  }));
                });
                // alert('003 suppressCartChange = true;')
                window.suppressCartChange = true;
              }else{
                document.dispatchEvent(new CustomEvent("variant:add", {
                  bubbles: true,
                  detail: {
                    items: responseJson.items || [responseJson],
                    cart: responseJson
                  }
                }));
                document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                  bubbles: true,
                  detail: {
                    baseEvent: "variant:add",
                    cart: responseJson,
                  },
                }));
                window.createCartPromise().then(cartData => {
                  if(document.querySelector('.header__cart-count cart-count')) {
                    document.querySelector('.header__cart-count cart-count').innerHTML = cartData.item_count;
                  }
                });
                // alert('004 suppressCartChange = true;');
                window.suppressCartChange = true;
              }
            }
          })
          .catch(error => {
            console.error('Error during cart update:', error);
            // alert('005 suppressCartChange = false;')
            window.suppressCartChange = false; // Ensure the flag is reset on error
          });
      } else {
        if (reloadPage) {
          window.location.reload();
        }
      }
    } else {
      if (reloadPage) {
        window.location.reload();
      }
    }
  })


}

document.addEventListener('DOMContentLoaded', () => {
  Array.from(document.querySelectorAll('label.color-swatch.rounded-full')).forEach((element) => {
    element.addEventListener('click', () => {
      let variant_option__subtitle = element.closest('fieldset').querySelector('.variant-option__subtitle span[data-att="option_subtitle"]');
      const str = element.querySelector('span').innerText;
      const capStr = str[0].toUpperCase() + str.slice(1);
      if (variant_option__subtitle)
        variant_option__subtitle.innerText = capStr;
    });
  });
});

var CustomModal = class extends HTMLElement {
  async connectedCallback() {
    this.closeBtns = Array.from(this.querySelectorAll('[data-close]'));
    this.closeBtns.forEach(btn => {
      btn.addEventListener('click', () => btn.hasAttribute('data-end-purchase') ? this.endPurchase() : this.close());
    })

    const openBtns = document.querySelectorAll('[data-show-custom-modal]');
    openBtns.forEach(btn => {
      if(btn.id === 'main-cta-button') {
        btn.addEventListener('click', (e) => {
          if(btn.hasAttribute('data-show-custom-modal')) {
            const id = btn.dataset.showCustomModal;
            const modal = document.querySelector('custom-modal#' + id);
            if(modal) modal.classList.add('custom-modal--open');

            document.querySelectorAll('#main-cta-button').forEach(b => b.removeAttribute('data-show-custom-modal'))

            btn.setAttribute('clicked-cta', 'true');
          }
        });
      } else {
        btn.addEventListener('click', () => {
          const id = btn.dataset.showCustomModal;
          const modal = document.querySelector('custom-modal#' + id);
          if(modal) modal.classList.add('custom-modal--open');
        });
      }
    })
  }

  close(){
    this.classList.remove('custom-modal--open')
  }

  open(){
    this.classList.add('custom-modal--open')
  }

  endPurchase(){
    const buyButton = document.querySelector('[clicked-cta]');

    if(buyButton !== null && !buyButton.hasAttribute('data-show-custom-modal'))
      buyButton.click();

    this.classList.remove('custom-modal--open')
  }
}

window.customElements.define("custom-modal", CustomModal);



var countDownSection = (() => {
  var startCountDown = (element) => {
    const jsDay = element.querySelector('[js-day]');
    const jsHour = element.querySelector('[js-hour]');
    const jsMinute = element.querySelector('[js-minute]');
    const jsSecond = element.querySelector('[js-second]');

    if (!jsDay || !jsHour || !jsMinute || !jsSecond) return;

    var goalDate = new Date(element.getAttribute('data-goal-date')).getTime();
    var timerId = setInterval(() => {
      var now = new Date().getTime();
      var distance = goalDate - now;

      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      jsDay.innerHTML = days;
      jsHour.innerHTML = hours;
      jsMinute.innerHTML = minutes;
      jsSecond.innerHTML = seconds;

      if (distance < 0) {
        clearInterval(timerId);
      }
    }, 1000);
  }
  var initialize = () => {
    document.querySelectorAll('[js-countdown]').forEach(element => {
      startCountDown(element);
    });
  }
  return {
    init: initialize
  }
})();

var deDEFormat = (() => {
  var initialize = () => {
    document.querySelectorAll('[js-de-DE-format]').forEach(element => {
      element.innerHTML = Number(element.innerHTML).toLocaleString('de-DE');
    });
  }
  return {
    init: initialize
  }
})();

var app = (() => {
  var initialize = () => {
    countDownSection.init();
  }
  return {
    init: initialize
  }
})();

document.addEventListener('DOMContentLoaded', () => {
  app.init();
  deDEFormat.init();
});

// custom quantity Updater plus minus
function updateQuantity(button, change) {
    const lineItem = button.closest("line-item-quantity");
    const quantityInput = lineItem.querySelector(".quantity-input");
    const removeLink = lineItem.querySelector(".link");

    let currentValue = parseInt(quantityInput.value, 10) || 0;
    let maxValue = parseInt(quantityInput.getAttribute("max"), 10) || 214;

    if (change === -1 && currentValue > 1) {
        quantityInput.value = currentValue - 1;
        quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
    } else if (change === -1 && currentValue === 1) {
        removeLink.click();
    } else if (change === 1 && currentValue < maxValue) {
        quantityInput.value = currentValue + 1;
        quantityInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
}

/** vDEV **/
/* [Section] Custom: Image with text */
var CustomImageWithTextTab = class extends HTMLElement {

  settings = {
    tabs: this.parentNode,
    list: document.getElementById(this.parentNode.getAttribute('aria-controls'))
  }

  constructor() {
    super();

    const tab = this;
    const tabLeft = parseInt(tab.getBoundingClientRect().left - tab.parentNode.getBoundingClientRect().left);
    tab.setAttribute('data-left', tabLeft);


    tab.addEventListener('click', this._select);

    if (tab.classList.contains('is-selected')) {
      tab._renderList();

      window.addEventListener('resize', () => {
        tab._renderList();
      });
    }
  }

  _scrollList(position) {
    const i = parseInt(position) - 1;

    const cardX = parseInt(getComputedStyle(this.settings.list).getPropertyValue('--list-items-per-row'));
    const card = this.settings.list.querySelector(`custom-image-with-text-card[data-position="${position}"]`);

    if (card) {
      const scrollCarousel = this.settings.list.closest('scroll-carousel');
      scrollCarousel.scrollLeft = card.getAttribute('data-left');

      const event = new CustomEvent('scroll:edge-nearing');
      scrollCarousel.dispatchEvent(event, {
        detail: {
          position: position
        }
      });
    }
  }

  _renderList() {
    const cards = this.settings.list.querySelectorAll('custom-image-with-text-card');

    if (!cards.length) {
      return false;
    }

    cards.forEach((card) => {
      const cardLeft = parseInt(card.getBoundingClientRect().left - this.settings.list.getBoundingClientRect().left);
      card.setAttribute('data-left', cardLeft);
    });
  }

  _select() {
    const tab = this;
    const tabPosition = tab.getAttribute('data-position');

    const tabs = tab.parentNode;
    const list = document.getElementById(tabs.getAttribute('aria-controls'));

    const selectedTab = this.settings.tabs.querySelector('custom-image-with-text-tab.is-selected');

    if (selectedTab) {
      selectedTab.classList.remove('is-selected');
    }

    tab.classList.add('is-selected');

    this._scrollList(tabPosition);
  }
};

if (!window.customElements.get('custom-image-with-text-tab')) {
  window.customElements.define('custom-image-with-text-tab', CustomImageWithTextTab);
}

var CustomImageWithTextList = class extends HTMLElement {

  constructor() {
    super();

    this._events();
  }

  _events() {
    const list = this;
    const scrollCarousel = list.closest('scroll-carousel');

    scrollCarousel.addEventListener('scroll', () => {
      list._scrollEvent();
    });

    scrollCarousel.addEventListener('scrollend', () => {
      list._scrollEvent();
    });
  }

  _scrollEvent() {
    const list = this;
    const scrollCarousel = list.closest('scroll-carousel');

    const listItemsX = parseInt(getComputedStyle(list).getPropertyValue('--list-items-per-row'));
    list.setAttribute('data-list-items-x', listItemsX);

    const listItems = list.children;

    if (!listItems.length) {
      return false;
    }

    /* Active item */
    let listActiveItemPosition = 1;

    for (let listItemI = 0; listItemI < listItems.length; listItemI++) {
      const listItem = listItems[listItemI];
      // const listItemLeft = parseInt(listItem.getBoundingClientRect().left - list.getBoundingClientRect().left);
      const listItemLeft = listItem.getBoundingClientRect().left;

      if (listItemLeft <= 0) {
        listActiveItemPosition = listItemI + 2;
      }
    }

    const tabs = this.closest('.section').querySelector('custom-image-with-text-tabs');

    const activeTab = tabs.querySelector('custom-image-with-text-tab.is-selected');
    activeTab.classList.remove('is-selected');

    const tab = tabs.querySelector(`custom-image-with-text-tab[data-position="${listActiveItemPosition}"]`);
    tab.classList.add('is-selected');
    /* /Active item */

    tabs.scrollTo({
      left: activeTab.getAttribute('data-left'),
      behavior: 'smooth'
    });
  }
};

if (!window.customElements.get("custom-image-with-text-list")) {
  window.customElements.define("custom-image-with-text-list", CustomImageWithTextList);
}
/* /[Section] Custom: Image with text */
/** /vDEV **/



class FullscreenModal extends HTMLElement {
  constructor() {
    super();

    this.closeButton = this.querySelector('button[data-close]')
    this.video = this.querySelector('video');
    this.addEvents();
  }

  addEvents() {
    this.addEventListener('click', event =>{
      if(event.target === event.currentTarget || event.target.closest("[data-close]")) this.close();
    })
    document.querySelectorAll(`[data-open="${this.id}"]`).forEach((el) => {
      el.addEventListener('click', e => {this.open()})
    })
  }

  open() {
    this.classList.add('visible');
    this.video?.play();

    document.body.classList.add('lock');
  }

  close() {
    this.classList.remove('visible');
    this.video?.pause();

    document.body.classList.remove('lock');
  }
}

if (!window.customElements.get("full-screen-modal")) {
  window.customElements.define("full-screen-modal", FullscreenModal);
}

// Parameter to automatically open the cart when the page loads (/?oc=1)
document.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('oc') === 'true' || urlParams.get('oc') === '1') {
    setTimeout(() => {
      document.querySelector('.header__icon-list a[aria-controls="cart-drawer"]').click();
    });
  }
});
